/**
 * Module-level shared state for DnD sidebar interactions.
 *
 * Avoids routing sidebar enter/exit through Zustand (which would trigger
 * React re-renders in DndListProvider and all its children). Instead, the
 * collision detection callback reads the ref directly, and body class
 * toggling happens synchronously in DOM event handlers.
 *
 * Safe as a singleton — only one DnD session runs at a time.
 */

/** Custom event dispatched when the pointer exits the sidebar during drag. */
export const DND_SIDEBAR_EXIT_EVENT = "dnd-sidebar-exit"

/**
 * Shared ref: `true` from the moment the pointer enters the sidebar until
 * DroppableRectRefresher has re-measured droppable rects after exit.
 *
 * - Set `true` by useSidebarDragOver on sidebar enter
 * - Stays `true` during the expand animation (rects are stale)
 * - Cleared by DroppableRectRefresher after measurement + timeout
 * - Read by multiDragCollision → returns `[]` when true (disables sort)
 */
export const isOverSidebarRef = { current: false }
